import Stack from '@mui/material/Stack';
import { styled } from '@mui/system';

import { AvatarProps } from './types';

const Avatar = styled(Stack, { shouldForwardProp: (prop) => prop !== 'emoji' })<AvatarProps>(
  ({ theme, emoji }) => ({
    textTransform: 'capitalize',
    background: emoji
      ? theme.palette.background.muted
      : 'linear-gradient(133deg, #2176FF 0%, #00D27A 100%)',
    color: theme.palette.text.emphasis,
    fontSize: emoji ? 16 : 12,
    fontWeight: 500,
    width: 24,
    height: 24,
    borderRadius: theme.shape.borderRadius,
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

export { Avatar };
